var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMegaphone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#005C83"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00263F"
    },
    d: "M512,256c0-1.167-0.029-2.326-0.044-3.489l-76.457-76.983l-0.37,0.572l-52.324-52.041l-19.309,32.332 l-56.79-56.79l-24.801,99.568L91.854,351.762L252.042,511.95c1.319,0.02,2.635,0.05,3.958,0.05C397.385,512,512,397.385,512,256z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#AE4E32"
    },
    points: "260.985,406.702 198.086,427.93 153.832,301.429 216.732,280.2 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M391.053,340.709c0,0-147.968-40.769-247.807-5.843l-26.665-76.223 C216.42,223.717,306.706,99.6,306.706,99.6L391.053,340.709z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M132.753,304.872l10.493,29.995c99.84-34.927,247.808,5.843,247.808,5.843l-42.635-121.875 L132.753,304.872z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6838"
    },
    d: "M306.706,99.6c0,0-11.298,15.526-30.305,37.131l67.809,193.835 c28.33,5.046,46.844,10.143,46.844,10.143L306.706,99.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AE4E32"
    },
    d: "M310.425,233.991l33.785,96.575c28.33,5.046,46.844,10.143,46.844,10.143l-42.635-121.875 L310.425,233.991z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FF6838"
    },
    points: "91.854,351.762 143.246,334.867 116.581,258.644 65.526,276.504 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#AE4E32"
    },
    points: "82.468,324.933 91.854,351.762 143.246,334.867 132.753,304.872 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.394,
    y: 162.883,
    transform: "matrix(-0.3905 -0.9206 0.9206 -0.3905 382.1416 650.4584)",
    style: {
      fill: "#FFDC00"
    },
    width: 20,
    height: 71.69
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFC000"
    },
    points: "443.31,193.939 438.922,183.595 372.724,211.127 377.31,221.939 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352.076,
    y: 117.651,
    transform: "matrix(-0.9167 -0.3996 0.3996 -0.9167 635.4045 425.6835)",
    style: {
      fill: "#FFDC00"
    },
    width: 20,
    height: 57.912
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.282,
    y: 258.281,
    transform: "matrix(-0.972 -0.2348 0.2348 -0.972 747.9791 625.6229)",
    style: {
      fill: "#FFC000"
    },
    width: 57.909,
    height: 19.999
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaphone);
export default __webpack_public_path__ + "static/media/megaphone.87f3c8264b1835fbc5f57e081d906e6c.svg";
export { ForwardRef as ReactComponent };